import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
	useMemo,
} from "react";
import {
	LogbookSettingsInitialState,
	type LogbookSettingsState,
} from "../reducers/LogbookSettingsReducer";

const LogbookSettingsContext = createContext<LogbookSettingsState>(
	LogbookSettingsInitialState,
);

export const useLogbookSettings = () => useContext(LogbookSettingsContext);

export const LogbookSettingsProvider = ({
	children,
	logbookSettings = {},
}: {
	children: ReactNode;
	logbookSettings?: Partial<LogbookSettingsState>;
}) => {
	// Merge default settings with provided settings
	const settings = useMemo(
		() => ({
			entry: {
				...LogbookSettingsInitialState.entry,
				...(logbookSettings.entry || {}),
			},
			report: {
				...LogbookSettingsInitialState.report,
				...(logbookSettings.report || {}),
			},
			section: {
				...LogbookSettingsInitialState.section,
				...(logbookSettings.section || {}),
			},
		}),
		[logbookSettings],
	);

	return (
		<LogbookSettingsContext.Provider value={settings}>
			{children}
		</LogbookSettingsContext.Provider>
	);
};
